function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 15H10.8l5.6-5.6L15 8l-8 8 8 8 1.4-1.4-5.6-5.6H23v-2z",
  fill: "#29354C"
});

var SvgIconBackDark = function SvgIconBackDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMyAxNUgxMC44TDE2LjQgOS40TDE1IDhMNyAxNkwxNSAyNEwxNi40IDIyLjZMMTAuOCAxN0gyM1YxNVoiIGZpbGw9IiMyOTM1NEMiLz4KPC9zdmc+Cg==";
export { SvgIconBackDark as ReactComponent };